import { PawPrint } from "lucide-react";

// "Benji Approved" seal — a tasteful stamp-style badge, not a cartoon.
export default function BenjiSeal({ className = "" }) {
  return (
    <div
      className={`inline-flex items-center gap-2 rounded-full border-2 border-forest/70 bg-cream px-4 py-1.5 text-forest shadow-sm ${className}`}
      data-testid="benji-seal"
    >
      <PawPrint className="h-4 w-4 text-gold-dark" strokeWidth={2.4} />
      <span className="font-heading text-xs font-bold uppercase tracking-[0.18em]">
        Benji Approved
      </span>
    </div>
  );
}
